import axiosInstance from "../axiosInstance";

const BASE_URL = "/hrm/dashboard";

// Lấy dữ liệu HRM dashboard (KPI + biểu đồ + danh sách gần nhất)
export const getHrmDashboard = async (params = {}) => {
  const response = await axiosInstance.get(BASE_URL, {
    params,
    withCredentials: true,
  });
  return response.data;
};

